import { useTranslation } from "react-i18next";
import * as S from "./style";

const coreSkills = [
  "TypeScript",
  "JavaScript",
  "Node.js",
  "React",
  "Next.js",
  "PostgreSQL",
];

const additionalSkills = [
  "AWS",
  "Terraform",
  "Microservices",
  "REST APIs",
  "Firebase",
  "Supabase",
  "React Native",
  ".NET",
  "Software Design",
  "Python",
  "Django",
  "MongoDB",
  "C#",
  "SQL",
  "Git",
];

const aiDevelopmentSkills = [
  "Claude Code",
  "OpenAI Codex",
  "Generative AI Tools",
];

const Skills = () => {
  const { t } = useTranslation("home");

  return (
    <S.Container>
      <S.Title>{t("skills")}</S.Title>
      <S.SkillGroup>
        <S.GroupTitle>{t("coreSkills")}</S.GroupTitle>
        <S.SkillList aria-label={t("coreSkills")}>
          {coreSkills.map((skill) => (
            <S.Skill key={skill}>{skill}</S.Skill>
          ))}
        </S.SkillList>
      </S.SkillGroup>
      <S.SkillGroup>
        <S.GroupTitle>{t("additionalSkills")}</S.GroupTitle>
        <S.SkillList aria-label={t("additionalSkills")}>
          {additionalSkills.map((skill) => (
            <S.Skill key={skill}>{skill}</S.Skill>
          ))}
        </S.SkillList>
      </S.SkillGroup>
      <S.SkillGroup>
        <S.GroupTitle>{t("aiDevelopmentSkills")}</S.GroupTitle>
        <S.SkillList aria-label={t("aiDevelopmentSkills")}>
          {aiDevelopmentSkills.map((skill) => (
            <S.Skill key={skill}>{skill}</S.Skill>
          ))}
        </S.SkillList>
      </S.SkillGroup>
    </S.Container>
  );
};

export default Skills;
